import {
  ON_FETCH_CONTRIBUTORS,
  ON_FETCH_CONTRIBUTORS_FAILURE,
  ON_FETCH_CONTRIBUTORS_SUCCESS,
} from '../actions/User';

export interface IState {
  user: any;
  dataTable: any;
  loading: boolean;
  error: string;
}

/** Reducer */
export default function userReducer(state: IState, action: any) {
  switch (action.type) {
    case ON_FETCH_CONTRIBUTORS:
      return {
        ...state,
        loading: true,
      };
    case ON_FETCH_CONTRIBUTORS_SUCCESS:
      return {
        ...state,
        user: action.user,
        dataTable: {
          ...state.dataTable,
          data: action.repos,
        },
        loading: false,
      };
    case ON_FETCH_CONTRIBUTORS_FAILURE:
      return {
        ...state,
        error: 'Failed to load data',
        loading: false,
      };
    default:
      return state;
  }
}
